module.exports = __webpack_public_path__ + "static/media/city-door-elements-svgrepo-com.f2e7585d.svg";